<template>
  <el-form
    class="date-time-select"
    inline
    :model="form"
    :rules="rules"
    v-bind="$attrs"
    @validate="validate"
  >
    <el-form-item style="padding: 0" prop="startTime">
      <el-date-picker
        v-model="form.startTime"
        type="datetime"
        placeholder="请选择起始时间"
        value-format="yyyy-MM-dd HH:mm:ss"
        default-time="00:00:00"
        @change="changeStartTime"
      />
    </el-form-item>
    <span style="margin-right: 20px;">至</span>
    <el-form-item style="padding: 0" prop="endTime">
      <el-date-picker
        v-model="form.endTime"
        type="datetime"
        placeholder="请选择终止时间"
        value-format="yyyy-MM-dd HH:mm:ss"
        default-time="23:59:59"
        @change="changeEndTime"
      />
    </el-form-item>
  </el-form>
</template>

<script>
import DateUtils from '@/utils/date'

export default {
  name: 'DateTimeSelect',

  props: {
    startTime: {
      type: String,
      default: ''
    },

    endTime: {
      type: String,
      default: ''
    }
  },

  data() {
    const startTimeValidate = (rule, value, callback) => {
      if (!this.form.startTime || !value) {
        callback()
      } else if (
        new Date(DateUtils.safeDate(value)) >
        new Date(DateUtils.safeDate(this.form.endTime))
      ) {
        callback(new Error('开始时间不能晚于截止时间'))
      }
      callback()
    }

    const endTimeValidate = (rule, value, callback) => {
      if (!value || !this.form.endTime) {
        callback()
      } else if (
        new Date(DateUtils.safeDate(value)) <
        new Date(DateUtils.safeDate(this.form.startTime))
      ) {
        callback(new Error('截止时间不能早于开始时间'))
      }
      callback()
    }

    return {
      form: {
        startTime: undefined,
        endTime: undefined
      },
      rules: {
        startTime: [
          { validator: startTimeValidate, trigger: ['blur', 'change'] }
        ],
        endTime: [{ validator: endTimeValidate, trigger: ['blur', 'change'] }]
      }
    }
  },

  watch: {
    startTime(value) {
      this.form.startTime = value
    },

    endTime(value) {
      this.form.endTime = value
    }
  },

  methods: {
    changeStartTime(value) {
      this.$emit('update:startTime', value)
    },

    changeEndTime(value) {
      this.$emit('update:endTime', value)
    },

    /**
     * 任意校验触发
     * @param {string} propName 校验的prop名称
     * @param {boolean} valid 校验结果
     */
    validate(propName, valid) {
      this.$emit('validate', valid)
    }
  }
}
</script>

<style lang="scss" scoped></style>
